import Localizr from '../utils/Localizr';
import Preloader from '../utils/Preloader';
import './multimedia.scss';
import ImageGallery from '../app/components/ImageGallery.NoTween';
import Resizer from '../utils/Resizer';
import VideoPlayerMP4 from '../app/components/VideoPlayerMP4';
import Sounds from '../app/Sounds';
import DisplayList from '../app/components/DisplayList';

class Multimedia {
  constructor() {
    this.layout();
    this.initGallery();
    this.initVideoPlayer();
    this.initStereos();
    Resizer.addListener(this.onResize.bind(this));
  }

  layout() {
    document.querySelector('#shell').appendChild(Localizr.template(Preloader.getFile('multimedia-template'), {}));

    Localizr.parseObjectList(settings.sections.multimedia.items);

    DisplayList.create(
        '<div class="mm-stereo-btn"><img src="{{thumb}}" alt="{{label}}"></div>',
        settings.sections.multimedia.stereograms,

        document.querySelector('.mm-buttons')
    );

    DisplayList.create(
        '<div class="mm-video-btn"><span>{{label}}</span></div>',
        settings.sections.multimedia.videos,

        document.querySelector('.mm-video-menu')
    );
  }

  initButtons() {}

  preenter() {}

  enter() {
    // trackPageView('About');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {
    const scale = document.querySelector('.mm-video-player').clientWidth / 370;
    document.querySelector('.mm-video-player-inner').style.transform = `scale(${scale}, ${scale})`;
  }

  initGallery() {
    new ImageGallery({
      shell: document.querySelector('.mm-gallery-inner'),
      lastBtn: document.querySelector('.mm-back'),
      nextBtn: document.querySelector('.mm-next'),
      images: settings.sections.multimedia.gallery,
      slideEnabled: false,
    });
  }

  initVideoPlayer() {
    this.videoNum = -1;
    this.totalTime = 0;
    this.curTime = 0;

    Array.from(document.querySelectorAll('.mm-video-btn')).forEach((btn, i) => {
      btn.addEventListener('click', () => {
        this.setVideo(i);
        this.player.play();
      });
    });
    this.setVideo(0);

    document.querySelector('.mm-play-button').addEventListener('click', () => {
      if (this.player.video.paused) {
        this.player.play();
      } else {
        this.player.pause();
      }
    });
    document.querySelector('.mm-video').addEventListener('click', () => {
      if (this.player.video.paused) {
        this.player.play();
      } else {
        this.player.pause();
      }
    });

    document.querySelector('.mm-enhance-btn').addEventListener('click', () => {
      const el = document.querySelector('.mm-video video');
      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.webkitEnterFullscreen) {
        el.webkitEnterFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen();
      }
    });
  }

  setVideo(num) {
    if (num == this.videoNum) {
      return;
    }
    this.videoNum = num;
    const selectedBtn = document.querySelector('.mm-video-btn.selected');
    if (selectedBtn) {
      selectedBtn.classList.remove('selected');
    }

    Array.from(document.querySelectorAll('.mm-video-btn'))[num].classList.add('selected');
    const durBarW = document.querySelector('.mm-progress-bar').clientWidth;
    const playHead = document.querySelector('.playhead');
    const playHeadW = playHead.clientWidth;
    if (this.player) {
      this.player.destroy();
    }
    const updateTime = () => {
      const duration = this.player.video.duration;
      const curTime = this.player.video.currentTime;
      const curMins = (curTime / 60) | 0;
      const curSecs = curTime % 60 | 0;
      const totalMins = (duration / 60) | 0;
      const totalSecs = duration % 60 | 0;
      const curStr = `${curMins < 10 ? '0' : ''}${curMins}:${curSecs < 10 ? '0' : ''}${curSecs}`;
      const totalStr = `${totalMins < 10 ? '0' : ''}${totalMins}:${totalSecs < 10 ? '0' : ''}${totalSecs}`;
      document.querySelector('#curTime').innerHTML = curStr;
      document.querySelector('#totalTime').innerHTML = totalStr;

      document.querySelector('selector');
      playHead.style.left = `${((durBarW - playHeadW) * curTime) / duration}px`;
    };

    const onVideoPause = () => {
      Sounds.appUnmute();
      document.querySelector('.mm-play-button').classList.remove('playing');
    };
    const onVideoPlaying = () => {
      Sounds.appMute();
      document.querySelector('.mm-play-button').classList.add('playing');
    };

    const videoData = settings.sections.multimedia.videos[num];
    document.querySelector('.mm-video-title').innerHTML = videoData.label;
    this.player = new VideoPlayerMP4({
      parent: document.querySelector('.mm-video'),
      ...videoData,
      events: {
        onpause: onVideoPause,
        onplaying: onVideoPlaying,
        onloadeddata: updateTime,
        ontimeupdate: updateTime,
      },
      playerOptions: {
        autoplay: false,
        preload: false,
        controls: false,
        poster: videoData.poster,
      },
    });
  }

  pauseVideo() {
    if (!this.player.video.paused) {
      this.player.pause();
    }
  }

  initStereos() {
    this.img = null;
    document.querySelector('.stereo-close').addEventListener('click', this.closeStereoModal);
    Array.from(document.querySelectorAll('.mm-stereo-btn')).forEach((btn, i) => {
      btn.addEventListener('click', () => this.openStereoModal(i));
    });
  }

  openStereoModal(sNum) {
    this.pauseVideo();
    document.querySelector('.stereo-modal').classList.add('open');
    this.img = new Image();
    this.img.src = settings.sections.multimedia.stereograms[sNum].image;
    document.querySelector('.stereo-modal-img').appendChild(this.img);
  }

  closeStereoModal() {
    document.querySelector('.stereo-modal').classList.remove('open');
    document.querySelector('.stereo-modal-img').innerHTML = '';
  }
}

export default Multimedia;
